<template>
  <b-container id="body-container" fluid>
    <b-row class="justify-content-center mb-5">
      <b-col cols="10">

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h5>Participates will leave with a great piece of content highlighting their current sales strategy and framing them as a champion. The show will provide them a free targeting strategy session with a top data expert and a sales strategy session with a top sales coach. They’ll walk away with a sales plan to execute and 100-500 highly targeted prospects based on their exact criteria. A month later our editors will produce another short piece of content for them to share describing the effect of the campaign.  </h5>
            </span>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h4 class="text-blackish title-body">Pre-Show</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h5>We send you a list of questions to prepare you to talk about your sales process. </h5>
            </span>
          </b-col>
        </b-row>



        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h4 class="text-blackish title-body">LIVE <i>(15-minutes)</i></h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <ol>
                <li>
                  <h5>You will describe your sales strategy, Total Addressable Market(TAM),  and ideal client profile (ICP) </h5>
                </li>
                <li>
                  <h5>A team of lead generation experts explain where to find their ICP on the internet and what data / trend helps clearly identify their audience </h5>
                </li>
                <li>
                  <h5>Our sales strategists will also talk you through a plan for an initial outreach campaign to execute </h5>
                </li>
              </ol>
            </span>
          </b-col>
        </b-row>




        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h4 class="text-blackish title-body">Post-Show</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <ol>
                <li>
                  <h5>Our strategists spend 15-45 minutes solidifying the plan that was laid out with the guest</h5>
                </li>
                <li>
                  <h5>Our data experts provide 100-500 highly targeted leads based on the conversation criteria </h5>
                </li>
                <li>
                  <h5>The guest executes the plan </h5>
                </li>
                <li>
                  <h5>We follow back up in a month to break down the effectiveness of the campaign. (5 minutes on camera) </h5>
                </li>
              </ol>
            </span>
          </b-col>
        </b-row>




        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h4 class="text-blackish title-body">Benefits for You (the Guest)</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <ol>
                <li>
                  <h5>Publicity for your company and product.</h5>
                  <ol>
                    <li>
                      <h5>Episodes are shared on YouTube and in our Facebook Channel at a minimum</h5>
                    </li>
                    <li>
                      <h5>We provide the speaker with the full episode and clips to share across their social media.</h5>
                    </li>
                  </ol>
                </li>
                <li>
                  <h5>Free targeted data drop - 100-500 highly targeted leads </h5>
                </li>
                <li>
                  <h5>A new sales strategy</h5>
                </li>
                <li>
                  <h5>Great call back content our 1-month follow up will re-engage your audience again.</h5>
                </li>
                <li>
                  <h5>We can identify your 100 top accounts to pursue if you are interested. </h5>
                </li>
              </ol>
            </span>
          </b-col>
        </b-row>


        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h4 class="text-blackish title-body">Apply or Nominate</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>
        <b-row class="pb-5">
          <b-row class="justify-content-center">
          <b-col md="5" cols="12" class="apply-button" style="">
            <a
              href="https://calendly.com/rosse/crush-your-quota-prescreen"
              class="d-flex justify-content-center"
            >
              <b-button class="free-trial-button" style="background:white; font-size: 15px; font-weight: 800; line-height: 20px; color: purple; border-radius: 10px; width: 253px; height: 50px;">Apply</b-button>
            </a>

          </b-col>
        </b-row>
        </b-row>
      </b-col>
    </b-row>



    <b-row id="launch-today-container" class="justify-content-center live-now">
      <b-col md="10">
        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="12" md="12">
            <span>
              <h4 class="text-blackish title-body" style="text-align:center; color:white">A community of Top Sales Performers like you.</h4>
            </span>
            <span>
              <b-row align-v="center" align-h="center">
                <h6 class="text-blackish" style="text-align:center; color:white; opacity: 0.5;">a community by</h6>
                <a href="/">
                  <img alt="gravity logo" src="../../assets/logo-150.png" />
                </a>
              </b-row>
            </span>
          </b-col>
        </b-row>

        <b-row class="justify-content-center">
          <b-col md="5" cols="12" class="buttons-center" >
            <a
              href="https://www.facebook.com/groups/themastersofmarketing/"
              class="d-flex justify-content-center"
            >
              <b-button class="free-trial-button">Join the community</b-button>
            </a>

            <!--
            <a
              href="https://www.launchgravity.com/masters-of-marketing/#upcoming"
              class="d-flex justify-content-center"
            >
              <b-button class="button-white-transparen"><b>Check our events</b></b-button>
            </a>
            -->
          </b-col>
        </b-row>
      </b-col>
    </b-row>


  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/screens/masters-of-marketing/body.sass
@import @/sass/screens/crush-your-quota/body.sass
@import @/sass/_components/main-card.sass
@import @/sass/screens/home/header.sass
</style>

<script>
// components
// import MainCard from '@/components/mainCard'
// import GuestCard from '@/components/guestCard'
// import HostCard from '@/components/hostCard'
// import PastGuestCard from '@/components/pastGuestCard'
// data
import { guests, yourDataGuys,yourSalesGurus } from '@/data/crush-your-quota.js'
import moment from 'moment'

export default {
  name: 'Body',
  components: {
    //MainCard,
    //GuestCard,
    //HostCard,
    //PastGuestCard,
  },
  data: function() {
    return {
      liveStream: {},
      featureSpeaker: [],
      pastSpeakers: [],
      futureSpeakers: [],
      pastSpeakersSortedList: [],
      guests,
      yourSalesGurus,
      yourDataGuys,
      timeToShow: 10,
      timer: null,
      currentDate: null,
      dayOfWeek: null,
      month: 1,
      day: 1,
      year: 2020,
      speakerSelection: 1,
      liveRightNow: 0,
      pastLen: 0,
      futureLen: 0,
    }
  },
  computed: {
    timeLeft() {
      return `${this.minutes} m ${this.seconds} seconds`
    },
    minutes() {
      return String(Math.floor(this.time / 60)).padStart(2, '0')
    },
    seconds() {
      return String(this.time % 60).padStart(2, '0')
    }
  },
  created() {
    this.orderSpeakers()
    this.setSpeakerRoles()
    this.pastSpeakersSorted()
    //this.timeToShow = this.getTimeToShow(),
    //this.timer = setInterval(this.decrement, 1000)
  },
  methods: {
    orderSpeakers() {
      var currentDate = new Date()
    
      for(var i in this.guests){
        var guestItem = this.guests[i]

        var speakingDate = guestItem.speakingDate
        var year = parseInt(speakingDate.substr(0, 4))
        var month = parseInt(speakingDate.substr(5, 6)) - 1
        var day = parseInt(speakingDate.substr(8, 9))
        var speakerDate = new Date(year, month, day, 0, 0, 0)
        var timeLeft = ((speakerDate - currentDate) / 86400000) + 0.416
        // var daysLeft = Math.ceil(timeLeft)

        // Store the dates back into the array
        guestItem.daysLeft = timeLeft
        var datePretty = speakerDate.toString().substr(0, 10)
        var ending = [
          '',
          'st',
          'nd',
          'rd',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'st',
          'nd',
          'rd',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'st',
        ]
        if (ending[day] !== undefined) {
          datePretty += ending[day]
        } else {
          datePretty += 'th'
        }
        guestItem.datePretty = datePretty
        if (timeLeft < 1 && timeLeft > -0.082) {
          //this.featuredSpeaker = index
          guestItem.speakerStatus = 1 // featured
        } else if (timeLeft < 3 && (datePretty.substr(0, 3) === 'Mon') && timeLeft > -0.082) {
          guestItem.speakerStatus = 1 // featured
        } else if (timeLeft < -0.041) {
          guestItem.speakerStatus = 0 // past
        } else {
          guestItem.speakerStatus = 2 // future
        }

        if (timeLeft < -0.041 && timeLeft > -0.082) {
          this.liveRightNow = 1
        }
      }
    },
    pastSpeakersSorted(){
      this.pastSpeakersSortedList = this.pastSpeakers.sort(function(a,b){ 
        var keyA = moment(a.speakingDate, "YYYY-MM-DD"),
        keyB = moment(b.speakingDate, "YYYY-MM-DD");

        if(keyA > keyB) return -1;
        if(keyA < keyB) return 1;
        return 0;
      });
    },
    setSpeakerSelection(page) {
      this.speakerSelection = page
    },
    setSpeakerRoles() {
      for (var i = 0; i < this.guests.length; i++) {
        if (this.guests[i].speakerStatus === 1) {
          console.log('Speaker Status')
          console.log(this.guests[i].speakerStatus)
          this.featureSpeaker.push(this.guests[i])
        } else if (this.guests[i].speakerStatus === 2) {
          this.futureSpeakers.push(this.guests[i])
        } else {
          this.pastSpeakers.push(this.guests[i])
        }
        this.liveStream = this.featureSpeaker[0]
      }
      this.pastLen = this.pastSpeakers.length
      this.futureLen = this.futureSpeakers.length
    },

    getTimeToShow() {
      // Get the day of the week = 2
      this.dayOfWeek
      // Get the current time = in date object
      this.currentDate
      // Make sure the timezone is correct

      // Timezone varies depending on Daylight Savings

      // Compare with current time in timezone SF
      // var pacificTime = new Date("2020-04-13T00:00:00.000+08:00")

      // Get Time Until 10:30 AM PST
      // If time before 10:30am PST
      // If time 10:30 - 11           M-F (Skip) Show LIVE NOW
      // If time after 11 am PST      Subtract Hours from 24

      // If Monday,Tuesday,Wed,Thurs

      // If Friday Afternoon

      // If Saturday    Add + 2 days

      // If Sunday morning      Add + 1 day (Afternoon subtract from 24)

      // If
      // If between 10:30 - 11:00 Monday - Friday (Skip) Show LIVE NOW
      //
    },
    decrement() {
      this.time = this.time - 1
    },
  },
}
</script>
